<div id="hymn-finder" class="full-size" heightObserver (heightChange)="onHeightChange($event)">
  <mat-toolbar id="hymn-finder-toolbar" class="sticky-toolbar mat-primary">

    <mat-toolbar-row>
      <ng-container>
        <span style="display: block; text-overflow: ellipsis">{{translation.title}}</span>

        <span class="toolbar-fill-remaining-space"></span>

        <button *ngIf="!searching" mat-icon-button (click)="clickSearch(true)">
          <mat-icon>search</mat-icon>
        </button>

        <button mat-icon-button *ngIf="layoutService.singleView" (click)="hymnSelectionService.dialpad()">
          <mat-icon>dialpad</mat-icon>
        </button>

        <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="layoutService.singleView">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" >

          <button *ngIf="layoutService.isNotBrowser()" mat-menu-item (click)="shareService.shareApp();">
            <mat-icon>share</mat-icon>
            <span>{{translation.share_app}}</span>
          </button>

          <button mat-menu-item *ngIf="layoutService.fullscreenSupported()" (click)="layoutService.toggleFullScreen()">
            <mat-icon *ngIf="!layoutService.fullscreen">fullscreen</mat-icon>
            <mat-icon *ngIf="layoutService.fullscreen">fullscreen_exit</mat-icon>
            <span>{{layoutService.fullscreen? translation.fullscreen_exit : translation.fullscreen}}</span>
          </button>

          <button mat-menu-item (click)="settingsService.toggleSettings()">
            <mat-icon>settings</mat-icon>
            <span>{{translation.settings}}</span>
          </button>
        </mat-menu>
      </ng-container>
    </mat-toolbar-row>
  </mat-toolbar>

  <ng-container *ngIf="searching">
    <div class="search-container">
      <mat-form-field class="search-input" subscriptSizing="dynamic">
        <input id="searchInput" #searchInput matInput (blur)="hymnSelectionService.searchFocus = false" (focus)="hymnSelectionService.searchFocus = true" (input)="search($event.target)" [placeholder]="translation.search_hymns">
      </mat-form-field>
      <button mat-icon-button (click)="clickSearch(false)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </ng-container>

  <div class="content">

    <ng-template #hymnCard let-hymn>
      <mat-card class="mat-card-list" style="margin: 7px; height: 100px;" (click)="onHymnSelected(hymn.hymnNumber)">
        <mat-card-header>
          <div class="card-padded-top" style="font-size: x-large;" mat-card-avatar>{{ hymn.hymnNumber | number:'3.0' }}</div>
          <mat-card-title [class.card-padded-top]="hymn.english == null">{{ hymn.title }}</mat-card-title>
          <mat-card-subtitle *ngIf="hymn.english">{{ hymn.english }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </ng-template>
    <mat-tab-group *ngIf="!searching" #tabs (selectedTabChange)="updateList($event)" [(selectedIndex)]="lastTabIndex" swipeGesture [axis]="'x'" (swipeleft)="onSwipeNext()" (swiperight)="onSwipePrevious()">
      <mat-tab>
        <ng-template mat-tab-label>
          {{tabList[0]}}
          <span *ngIf="showNewFeaturesLabel"
            class="new-badge">{{translation.new}}</span>
        </ng-template>

        <mat-card class="mat-card-list"
                  style="margin: 7px; height: 100px;"
                  (click)="guessTheHymn()">
          <mat-card-header>
            <img alt="Raai die Loflied" src="assets/icons/hymn-dash.png" mat-card-avatar class="card-icon"/>
            <!--            <mat-icon mat-card-avatar class="card-icon">question_mark</mat-icon>-->
            <mat-card-title>{{translation.card_title_guess_the_hymn}}</mat-card-title>
            <mat-card-subtitle>{{translation.card_description_guess_the_hymn}}</mat-card-subtitle>
          </mat-card-header>
        </mat-card>

        <mat-card *ngIf="layoutService.isNotBrowser()" class="mat-card-list"
                  style="margin: 7px; height: 100px;"
                  (click)="openBrowser()">
          <mat-card-header>
            <mat-icon mat-card-avatar class="card-icon">travel_explore</mat-icon>
            <mat-card-title>{{translation.use_online}}</mat-card-title>
            <mat-card-subtitle>{{translation.use_online_description}}</mat-card-subtitle>
          </mat-card-header>
        </mat-card>

      </mat-tab>

      <mat-tab [label]="tabList[1]">
        <cdk-virtual-scroll-viewport cdk-virtual-scroll-viewport-resize-aware id="list-container" class="virtual-scroll-container" itemSize="107">
          <ng-container *cdkVirtualFor="let card of hymns; templateCacheSize: 50">
            <mat-card class="mat-card-list"
              *ngIf="card.static; else hymnCardTemplate"
              style="margin: 7px; height: 100px;"
              (click)="card.action()">
              <mat-card-header>
                <mat-icon mat-card-avatar class="card-icon">{{ card.icon }}</mat-icon>
                <mat-card-title>{{ card.title }}</mat-card-title>
                <mat-card-subtitle>{{ card.subtitle }}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
            <ng-template #hymnCardTemplate>
              <ng-container *ngTemplateOutlet="hymnCard; context: {$implicit: card}"></ng-container>
            </ng-template>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </mat-tab>

      <mat-tab [label]="tabList[2]">
        <ng-container *ngIf="getCombinedFavorites().length > 0; else emptyListTemplate">
          <cdk-virtual-scroll-viewport
            cdk-virtual-scroll-viewport-resize-aware
            id="favorites-container"
            class="virtual-scroll-container"
            itemSize="107">

            <ng-container *cdkVirtualFor="let hymn of getCombinedFavorites(); templateCacheSize: 50">
              <mat-card class="mat-card-list"
                        *ngIf="hymn.static; else hymnCardTemplate"
                        style="margin: 7px; height: 100px;"
                        (click)="hymn.action()">
                <mat-card-header>
                  <mat-icon mat-card-avatar class="card-icon">{{ hymn.icon }}</mat-icon>
                  <mat-card-title>{{ hymn.title }}</mat-card-title>
                  <mat-card-subtitle>{{ hymn.subtitle }}</mat-card-subtitle>
                </mat-card-header>
              </mat-card>
              <ng-template #hymnCardTemplate>
                <ng-container *ngTemplateOutlet="hymnCard; context: {$implicit: hymn}"></ng-container>
              </ng-template>
            </ng-container>
          </cdk-virtual-scroll-viewport>
        </ng-container>

        <ng-template #emptyListTemplate>
          <mat-card class="mat-card-list" style="margin: 7px; padding: 20px; text-align: center;">
            <mat-card-content>{{translation.no_favorites}}</mat-card-content>
          </mat-card>
        </ng-template>
      </mat-tab>

      <mat-tab [label]="tabList[3]">
        <ng-container *ngIf="settingsService.getHymnsToLearn().length > 0; else emptyLearnListTemplate">
          <cdk-virtual-scroll-viewport
            cdk-virtual-scroll-viewport-resize-aware
            id="learn-container"
            class="virtual-scroll-container"
            itemSize="107">

            <ng-container *cdkVirtualFor="let hymn of settingsService.getHymnsToLearn(); templateCacheSize: 50">
              <ng-container *ngTemplateOutlet="hymnCard; context: {$implicit: hymn}"></ng-container>
            </ng-container>

          </cdk-virtual-scroll-viewport>
        </ng-container>

        <ng-template #emptyLearnListTemplate>
          <mat-card class="mat-card-list" style="margin: 7px; padding: 20px; text-align: center;">
            <mat-card-content>{{translation.no_hymns_to_learn}}</mat-card-content>
          </mat-card>
        </ng-template>
      </mat-tab>

      <mat-tab [label]="tabList[4]">
        <ng-container *ngIf="settingsService.getHistory().length > 0; else emptyHistoryListTemplate">
          <cdk-virtual-scroll-viewport
            cdk-virtual-scroll-viewport-resize-aware
            id="alphabetic-container"
            class="virtual-scroll-container"
            itemSize="107">

            <ng-container *cdkVirtualFor="let hymn of settingsService.getHistory(); templateCacheSize: 50">
              <ng-container *ngTemplateOutlet="hymnCard; context: {$implicit: hymn}"></ng-container>
            </ng-container>

          </cdk-virtual-scroll-viewport>
        </ng-container>

        <ng-template #emptyHistoryListTemplate>
          <mat-card class="mat-card-list" style="margin: 7px; padding: 20px; text-align: center;">
            <mat-card-content>{{translation.no_history}}</mat-card-content>
          </mat-card>
        </ng-template>
      </mat-tab>

    </mat-tab-group>

    <cdk-virtual-scroll-viewport cdk-virtual-scroll-viewport-resize-aware id="search-container" class="virtual-scroll-container" *ngIf="searching" itemSize="107">
      <div *cdkVirtualFor="let hymn of searchResults; templateCacheSize: 50" class="list-item">
        <mat-card class="mat-card-list" style="margin: 7px; height: 100px;" (click)="onHymnSelected(hymn.hymnNumber)" >
          <mat-card-header>
            <div class="card-padded-top" style="font-size: x-large;" mat-card-avatar>{{ hymn.hymnNumber | number:'3.0' }}</div>
            <mat-card-title [class.card-padded-top]="hymn.english == null">{{ hymn.title }}</mat-card-title>
            <mat-card-subtitle *ngIf="hymn.english">{{ hymn.english }}</mat-card-subtitle>
          </mat-card-header>
        </mat-card>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
